#import "../fragments/ContactListFields.graphql"

mutation CreateContactList($name: String!) {
  createContactList(name: $name) {
    ...ContactListFields
  }
}
